module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "id": "getting-started"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "align-self": "center"
    }
  }, [_c('h3', [_vm._v("Thanks for installing rmCloud!")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        You'll now see a link to the app in the main navigation:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location.png",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        Or, in the newer navigation it will be in the top of the screen:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location-new.png",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        For instructions on how to use rmCloud, "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://purpledrapes.atlassian.net/wiki/spaces/RD/pages/86933579/Getting+started"
    }
  }, [_vm._v("check out the Getting started page")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        For a quick overview of using rmCloud, check out the video below:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/P94bDH38vhE",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        If you ever need help (feature requests, bugs, not sure how to do something),\n        just click the \"Get help\" button in the bottom right corner of the main app:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/get-help-button.png"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-798e88cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/GettingStartedView.vue
// module id = 1020
// module chunks = 1